<template>
  <div class="theme-container">
    <slot />
  </div>
</template>

<script setup lang="ts" name="ThemeProvider"></script>

<style lang="scss" scoped>
// 这次使用到的/有变化的有言CSS颜色变量
.theme-container {
  // white
  --white-1: rgba(255, 255, 255, 1);
  --white-3: rgba(255, 255, 255, 0.8);
  --white-5: rgba(255, 255, 255, 0.6);
  --white-8: rgba(255, 255, 255, 0.3);
  --white-9: rgba(255, 255, 255, 0.2);
  --white-10: rgba(255, 255, 255, 0.1);

  // 文本色
  --text-1: rgb(4, 11, 24);
  --text-3: rgba(65, 71, 81, 1);
  --text-5: rgba(109, 113, 121, 1);
  --text-8: rgba(176, 179, 182, 1);

  // 背景色
  --back-1: rgb(255, 255, 255); //#FFFFFF 白/背景
  --back-2: rgba(249, 250, 253, 1);
  --back-3: rgba(240, 242, 245, 1); //#F0F2F5 浅/容器背景
  --back-4: rgba(232, 234, 238, 1); // 分割线
  --back-5: rgba(220, 222, 227, 1);
  --back-6: rgba(201, 205, 211, 1); // #C9CDD3
  --back-7: rgba(167, 172, 182, 1); // 分割线

  // purple
  --purple-1: rgba(243, 244, 255, 1);
  --purple-7: rgba(86, 80, 220, 1);
  --purple-8: rgba(69, 60, 184, 1);
}
</style>
